import { getDefaultHeader } from '../../services/serviceAPIHelper';

export const getSpecialDestinations = function(value, accountName='b2bweberoski', type){
    
    let url = process.env.REACT_APP_API_URL + `specialDestinations/list/${accountName}?name=${value ? value : ''}`;
    if (type) {
        url += `&type=${type}`;
    }
    return fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const getSpecialDestinationHotels = function(specialDestination){
    
    const url = process.env.REACT_APP_API_URL + `specialDestinations/${specialDestination._id}/hotels`;
    return fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const addSpecialDestination = function(specialDestination){
    
    const url = process.env.REACT_APP_API_URL + 'specialDestinations/';
    return fetch(url, {
        method: 'POST',
        headers: getDefaultHeader(true),
        body:JSON.stringify(specialDestination)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const updateSpecialDestination = function(specialDestination){
    const url = process.env.REACT_APP_API_URL + 'specialDestinations/' + specialDestination._id;
    return fetch(url, {
        method: 'PUT',
        headers: getDefaultHeader(true),
        body:JSON.stringify(specialDestination)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};

export const deleteSpecialDestination = function(specialDestination){
    const url = process.env.REACT_APP_API_URL + 'specialDestinations/' + (specialDestination.id ? specialDestination.id : specialDestination._id);
    return fetch(url, {
        method: 'DELETE',
        headers: getDefaultHeader(true)
    }).then(response => {
        if(response.ok) {    
            return response.json();
        } else {
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
};




// WEBPACK FOOTER //
// ./src/components/SpecialDestinations/SpecialDestinationServices.js